import type { UnpricedModelView } from '@/lib/api/generated/model';

/**
 * Builds a `model_key → run info` lookup from the current period's unpriced-models
 * list (spec 092 follow-up), the same shape decision as `buildModelPriceLookup`.
 *
 * A model with a null `model_key` is dropped: there is nothing to key it by, and
 * every caller only ever looks this up by a model it already knows the name of.
 */
export function buildUnpricedModelRunsLookup(
  models: UnpricedModelView[],
): Map<string, UnpricedModelView> {
  const lookup = new Map<string, UnpricedModelView>();
  for (const model of models) {
    if (model.model_key !== null) lookup.set(model.model_key, model);
  }
  return lookup;
}
